module.exports = __webpack_public_path__ + "static/media/squares.b5bd3820.png";